
const login = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/login/login.vue")), "views");
const register = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/login/register.vue")), "views");
const shop = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/shop/index.vue")), "views");
const accountSettings = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/common/accountSettings.vue")), "views");
const changePassword = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/common/changePassword.vue")), "views");
const industryType = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/shop/industryType/index.vue")), "views");
const versionPayment = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/versionPayment/index.vue")), "views");
const versionShoppingCart = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/versionPayment/shoppingCart.vue")), "views");
const versionPayResult = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/versionPayment/payResult.vue")), "views");
const versionPaType = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/versionPayment/payType.vue")), "views");
const versionOrder = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/versionPayment/order.vue")), "views");

// const console = (resolve: any) => (<any>require).ensure([], () => resolve(require("views/console/index.vue")), "views");

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap =
[
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: "login",
        component: login,
        hidden: true,
    },
    {
        path: '/register',
        name: "register",
        component: register,
        hidden: true,
    },
    {
        path: '/shop',
        name: 'shop',
        component: shop
    },
    // {
    //     path: '/console',
    //     component: console
    // },
    {
        path: '/accountSettings',
        name: "accountSettings",
        component: accountSettings
    },
    {
        path: '/changePassword',
        name: "changePassword",
        component: changePassword
    },
    {
        path: '/industryType',
        name: "industryType",
        component: industryType
    },
    {
        path: '/versionPayment',
        name: "versionPayment",
        component: versionPayment
    },
    {
        path: '/versionShoppingCart',
        name: "version-shoppingCart",
        component: versionShoppingCart
    },
    {
        path: '/versionPayResult',
        name: "version-payResult",
        component: versionPayResult
    },
    {
        path: '/versionPaType',
        name: "version-paType",
        component: versionPaType
    }
    // {
    //     path: '/versionOrder',
    //     name: "version-order",
    //     component: versionOrder
    // }
    
]